import { Grid, Typography, Card, CardContent, Box, Avatar } from '@mui/material';
import { motion } from 'framer-motion';

const teamMembers = [
  {
    name: "Yossi Teichman",
    title: "Founder & Managing Partner",
    bio: "15+ years experience in private and public equities, real estate and debt. Deployed $50M+ of capital through different financial cycles, averaging 20%+ returns.",
    image: "/yossi-teichman.jpg"
  },
  {
    name: "Sarah Chen",
    title: "Partner, Investments",
    bio: "Former investment professional at a leading GP stakes firm with extensive experience in private market valuations and manager selection.",
    image: "/sarah-chen.jpg"
  },
  {
    name: "Michael Rodriguez",
    title: "Partner, Portfolio Management",
    bio: "Specializes in value creation and operational improvements for alternative asset managers with a focus on technology implementation.",
    image: "/michael-rodriguez.jpg"
  }
];

const TeamSection = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: '#f5f7fa', padding: 10}}>
      <Typography variant="h3" component="h2" align="center" sx={{ mb: 6, fontWeight: 'bold' }}>
        Our Team
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {teamMembers.map((member, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card sx={{ height: '100%', boxShadow: 3 }}>
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <Avatar 
                    alt={member.name} 
                    src={member.image} 
                    sx={{ 
                      width: 120, 
                      height: 120, 
                      mb: 3,
                      mx: 'auto',
                      border: '3px solid #1976d2'
                    }} 
                  />
                  <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {member.name}
                  </Typography>
                  <Typography variant="subtitle1" color="primary" gutterBottom>
                    {member.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {member.bio}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TeamSection;
